import { StepperHeader } from '../../../../atoms/FormStepper/StepperHeader';
import { GenerateSimulationButton } from '../components/GenerateSimulationButton';
import { ParameterField, ParameterGroup } from './components';
import { useCustomTranslation } from '../../../../../hooks';
import { useSuspenseGetGraphneSimulationParameters } from '../hooks';
import { groupParameters } from './groupSimulationParameters';

type GanttSimulationParametersProps = {
  onChangeStep: () => void;
  cancelButton: React.ReactNode;
  submitButtonLabel: string;
  headerTitle?: string;
};

export const GanttSimulationParameters = ({
  onChangeStep: _onChangeStep,
  cancelButton,
  submitButtonLabel,
  headerTitle,
}: GanttSimulationParametersProps) => {
  const { data } = useSuspenseGetGraphneSimulationParameters();
  const { tWrapper } = useCustomTranslation('products.simulationPlan');
  const groups = groupParameters(data);
  const hasNoParameters = data.length === 0;

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <StepperHeader
        currentStepIndex={0}
        // stepsCount={2}
        // subtitle={tWrapper('stepOneParameters')}
        stepsCount={0}
        // subtitle={tWrapper('parameters')}
        title={headerTitle ?? tWrapper('newSimulationForDates')} // TODO: add correct dates
      />
      <div className="flex-1 overflow-auto p-8">
        <div className="m-auto flex w-full max-w-380 flex-col gap-7">
          {!hasNoParameters && <span className="text-s18">{tWrapper('parametersIntro')}</span>}
          <div className="flex flex-col gap-8">
            {groups.map((group) => (
              <ParameterGroup key={group.name} title={group.name}>
                {group.parameters.map((parameter) => (
                  <ParameterField
                    from={parameter.from}
                    key={parameter.id}
                    label={parameter.name}
                    name={parameter.id.toString()}
                    parameterType={parameter.parameterType}
                    required={!parameter.isOptional}
                    to={parameter.to}
                  />
                ))}
              </ParameterGroup>
            ))}
          </div>
          {hasNoParameters && <span className="text-s18">{tWrapper('noParameters')}</span>}
        </div>
      </div>
      <div className="flex items-center justify-between border-t border-border-primary px-8 py-2">
        {/* <span className="text-s18">{tWrapper('stepOneParameters')}</span> */}
        <span className="text-s18">{/*{tWrapper('parameters')}*/}</span>
        <div className="flex gap-4">
          {cancelButton}
          {/* TODO: uncomment when implement availability step */}
          <GenerateSimulationButton submitButtonLabel={submitButtonLabel} />
          {/* <Button EndIcon={<FontAwesomeIcon icon={faArrowRight} />} variant="contained" onClick={onChangeStep}>
            {tWrapper('nextAvailability')}
          </Button> */}
        </div>
      </div>
    </div>
  );
};
